import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const anvilogic = defineConnector({
  identifier: "anvilogic",
  name: "Anvilogic",
  tagLine: "Security detection and hunting",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://secure\\.anvilogic\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Anvilogic tenant](https://secure.anvilogic.com/settings), open **Settings**, and create a **New API Key**.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "Anvilogic API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://secure.anvilogic.com/api/v1/health",
  },
});
